import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';

import { BILLING_SETTINGS_LIST_PERMISSION } from '&/features/billing/paths';

export const Route = createFileRoute('/_authenticated/settings_/territories/$territoryId/billing')({
  beforeLoad: ({ context, params }): void => {
    // Permission: without `billing-settings:list`, back to the territory's General tab, as sibling tabs do.
    // No module gate — Billing is not a module surface. The page re-checks on a hard refresh.
    if (context.permissions.isReady && !context.permissions.hasPermission(BILLING_SETTINGS_LIST_PERMISSION)) {
      throw redirect({ params: { territoryId: params.territoryId }, to: '/settings/territories/$territoryId' });
    }
  },
  component: lazyRouteComponent(
    () => import('&/features/billing/pages/territory-billing-settings-page'),
    'TerritoryBillingSettingsPage',
  ),
  staticData: { titleKey: 'billingSettings' },
});
